import { FormControl } from "@angular/forms";
import { EventColor } from "calendar-utils";
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { subYears } from 'date-fns';

export const emailPattern = /^[a-zA-Z0-9]+[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z.]{2,6}$/;
export const mobilePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

export function formatAmount(amount: any) {
	if (!isNaN(amount) && amount != null && amount != undefined) {
		return amount.toLocaleString();
	} else {
		return amount;
	}
}

export function password_validation(control: FormControl) {
	let password: any = control.value;
	if (password == null || password == undefined) {
		password = "";
	}
	let errObj: any = {};
	if (password.length < 8) {
		errObj.minlengtherror = true;
	}
	const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
	if (!specialChars.test(password)) {
		errObj.specialcharerror = true;
	}
	const upper = /[A-Z]/;
	const lower = /[a-z]/;
	const digit = /\d/;
	if (!upper.test(password)) {
		errObj.uppercaseerror = true;
	}
	if (!lower.test(password)) {
		errObj.lowercaseerror = true;
	}
	if (!digit.test(password)) {
		errObj.digiterror = true;
	}
	return errObj ? errObj : null;
}

export function noWhitespaceInRequiredValidator(control: FormControl) {
	let val: any = control.value;
	if (val == null) {
		return { 'required': true };
	}
	let type = typeof val;
	if (type == "number" || type == "bigint" || type == "object") {
		return null;
	}
	const isWhitespace = (control.value || '').trim().length === 0;
	const isValid = !isWhitespace;
	return isValid ? null : { 'required': true };
}

export const colors: Record<string, EventColor> = {
	primary: {
		primary: '#0D6EFD',
		secondary: '#c1daff',
	},
	secondary: {
		primary: '#6C757D',
		secondary: '#cadbe9',
	},
	success: {
		primary: '#198754',
		secondary: '#b5f5d7',
	},
	danger: {
		primary: '#DC3545',
		secondary: '#d8acb0',
	},
	warning: {
		primary: '#D3A10E',
		secondary: '#d3c18a',
	},
	info: {
		primary: '#0DCAF0',
		secondary: '#bfeaf3',
	}
};

export function convertToNgbDate(date: Date): NgbDate {
	return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
}

export const datePickerMinDate = convertToNgbDate(subYears(new Date(), 100));

/* paymentList:any = [{id:1,name:"Payment Done"},{id:2,name:"Payment Not Done"},{id:3,name:"By Company"},{id:4,name:"By Candidate"}]; */
export const paymentList: any = [{ id: 1, name: "Cash/Bank TFR" }, { id: 1, name: "Razorpay" }, /* { id: 1, name: "Bank TFR" }, */ { id: 2, name: "Company" }, { id: 3, name: "NA" }, { id: 4, name: "Not Done" }];

export const apptStatusList: any = [
	{ id: "BOOKED", name: "BOOKED" },
	/* { id: "REGISTERD", name: "REGISTERD" }, */
	{ id: "COMPLETED", name: "COMPLETED" },
	/* { id: "PENDING", name: "PENDING" }, */
	{ id: "CANCELED", name: "CANCELED" },
	/* { id: "RESCHEDULED", name: "RESCHEDULED" }, */
	{ id: "TEST COMPLETE", name: "TEST COMPLETE" },
	{ id: "TEST INCOMPLETE", name: "TEST INCOMPLETE" },
	{ id: "BOOKED BY COMPANY", name: "BOOKED BY COMPANY" },
];

/* pay_mod:any=[{'id':1,'pay_mod':'Cash'},{'id':2,'pay_mod':'Online'},{'id':3,'pay_mod':'Company'},{'id':4,'pay_mod':'Bank Transfer'},{'id':5,'pay_mod':'Included with Swat'}]; */
export const pay_mod: any = [{ 'id': 1, 'pay_mod': 'Candidate' }, { 'id': 2, 'pay_mod': 'Company' }, { 'id': 3, 'pay_mod': 'NA' }];

export const purposeList = [
	{ 'id': 1, 'name': 'Prejoining' },
	{ 'id': 2, 'name': 'Promotion' },
	{ 'id': 3, 'name': 'RTW' },
	{ 'id': 4, 'name': 'Sign off' },
	{ 'id': 5, 'name': 'New hire' },
	{ 'id': 6, 'name': 'Current employee' },
	{ 'id': 7, 'name': 'RMA' },
];

export const callStatusList = [
	{
		'val': 'MissCall',
		'name': 'Missed Calls',
		'name1': 'Missed',
		'img1': 'missed-call.png',
		'img2': 'missed-call.png',
		'count_key': 'misscallcount',
		'color': '#F44336'
	},
	{
		'val': 'Received',
		'name': 'Received Calls',
		'name1': 'Received',
		'img1': 'answered-call.png',
		'img2': 'incoming-call.png',
		'count_key': 'Receivedcount',
		'color': '#4CAF50'
	},
	{
		'val': 'outgoing',
		'name': 'Outgoing Calls',
		'name1': 'Outgoing',
		'img1': 'outgoing-call-1.png',
		'img2': 'outgoing-call.png',
		'count_key': 'outgoingcount',
		'color': '#32BEA6'
	}
];

export function isImage(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "png" || ext_lower == "jpg" || ext_lower == "jpeg" || ext_lower == "jfif" || ext_lower == "gif";
	} catch (error) {
		return false;
	}
}

export function isPdf(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "pdf";
	} catch (error) {
		return false;
	}
}

export const splitPattern = new RegExp('[,;\t\r\n]+');